import button from './AddButton.vue'
const AddButton = {
  install: function (Vue) {
    Vue.component('AddButton', button)
  }
}
export default AddButton
